import {
  BasePatch,
  DocumentBase,
  OfferBase,
  OfferBasePatch,
  patchDocumentBase,
  patchOfferBase,
} from "@/services/backend/documents/types/base";
import { ScopeOfWork } from "@/services/backend/omni/scope-of-work/types/scope-of-work";
import {
  patchPricing,
  patchPricingBy,
  Pricing,
  PricingBy,
  PricingByPatch,
  PricingPatch,
} from "@/services/backend/omni/pricing/types/pricing";

/** Mirrors `offer.Offer`, backend/core/omni/domain/offer/offer.go. */
export type Offer = DocumentBase &
  OfferBase & {
    scopeOfWork: ScopeOfWork[];
    pricing: Pricing;
    pricingBy: PricingBy;
  };

/** Mirrors `offer.Patch`, backend/core/omni/domain/offer/offer.go. */
export type Patch = BasePatch &
  OfferBasePatch & {
    pricing?: PricingPatch;
    pricingBy?: PricingByPatch;
  };

export function patchOffer(offer: Offer, patch: Patch): Offer {
  let patched = patchDocumentBase(offer, patch);
  patched = patchOfferBase(patched, patch);
  patched = {
    ...patched,
    pricing: patchPricing(patched.pricing, patch.pricing),
    pricingBy: patchPricingBy(patched.pricingBy, patch.pricingBy),
  };

  return patched;
}

/**
 * patchScopeOfWorkOfOffer returns the offer with fn applied to its scope of
 * work scopeOfWorkId, e.g. for an optimistic cache update. Other scope of
 * works are returned as they are.
 */
export function patchScopeOfWorkOfOffer(
  offer: Offer,
  scopeOfWorkId: string,
  fn: (scopeOfWork: ScopeOfWork) => ScopeOfWork,
): Offer {
  return {
    ...offer,
    scopeOfWork: offer.scopeOfWork.map((sow: ScopeOfWork) =>
      sow.id === scopeOfWorkId ? fn(sow) : sow,
    ),
  };
}
